import { render } from "./MultiTrainingViewer.vue?vue&type=template&id=b124de1e"
import script from "./MultiTrainingViewer.vue?vue&type=script&lang=js"
export * from "./MultiTrainingViewer.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__